/*
 *
 * ProfileAmbassador actions
 *
 */

import {
  GET_PLANS_FAILED,
  GET_PLANS_SUCCESS,
  GET_PLANS_WATCHER,
  UPDATE_PHOTO_WATCHER,
  UPDATE_PHOTO_SUCCESS,
} from "./constants"

export function updatePhotoWatcher(payload) {
  return {
    type: UPDATE_PHOTO_WATCHER,
    payload,
  }
}

export function updatePhotoSuccess(payload) {
  return {
    type: UPDATE_PHOTO_SUCCESS,
    payload,
  }
}

export function getPlansWatcher(payload) {
  return {
    type: GET_PLANS_WATCHER,
    payload,
  }
}

export function getPlansSuccess(payload) {
  return {
    type: GET_PLANS_SUCCESS,
    payload,
  }
}

export function getPlansFailed() {
  return { type: GET_PLANS_FAILED }
}
